import { Modal } from 'react-bootstrap';
import exportIcon from '../../assets/images/export.svg';
import closeIcon from '../../assets/images/close-white.svg';
import { useState } from 'react';
import { axiosInstance } from '../../config/axiosConfig';
import loaderService from '../../service/loaderService';
import { showError } from '../../service/toastService';
import SuccessModal from '../SuccessModal/SuccessModal';
import { ADD_TEMPLATE } from '../../config/endpoint';

const TemplateUploadModal = ({ show, setShow, callback }) => {
  const [templateFile, setTemplateFile] = useState(null);
  const [dragOver, setDragOver] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const handleClose = () => {
    setTemplateFile(null);
    setShow(false);
  };

  const handleSuccessClose = () => {
    setShowSuccess(false);
  };

  const handleFileUpload = (files) => {
    const file = files[0];
    const isDocx = file && file.name.toLowerCase().endsWith('.docx');
    if (!isDocx) {
      showError('Only .docx files are allowed.');
      return;
    }
    setTemplateFile(file);
  };

  const uploadTemplate = async () => {
    if (!templateFile) {
      showError('Please upload a .docx file.');
      return;
    }

    const formData = new FormData();
    formData.append('templateFile', templateFile);

    loaderService.show();
    try {
      await axiosInstance.post(ADD_TEMPLATE, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if(callback){
        callback();
      }
      setShow(false);
      setShowSuccess(true);
    } catch (err) {
      showError(err?.response?.data?.message || 'Upload failed.');
    } finally {
      loaderService.hide();
    }
  };

  return (
    <>
      <Modal dialogClassName="custom-modal" show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>Upload Template File</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className={`drop-section ${dragOver ? 'drag-over' : ''}`}
            onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
            onDragLeave={() => setDragOver(false)}
            onDrop={(e) => {
              e.preventDefault();
              setDragOver(false);
              handleFileUpload(e.dataTransfer.files);
            }}
          >
            <input
              type="file"
              id="template-upload"
              accept=".docx"
              style={{ display: 'none' }}
              onChange={(e) => handleFileUpload(e.target.files)}
            />
            <p className="font-16">Drag & drop or click to upload your .docx file</p>
            <button className="theme-blue-btn" onClick={() => document.getElementById('template-upload').click()}>
              <img src={exportIcon} alt="export" />
              <span>Upload .docx</span>
            </button>
          </div>

          {templateFile && (
            <div className="drop-section mt-3">
              <div className="file-detail d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center gap-16">
                  <div>
                    <p className="font-16" style={{ overflowWrap: 'anywhere' }}>{templateFile.name}</p>
                    <p className="font-14">Ready to upload</p>
                  </div>
                </div>
                <img
                  src={closeIcon}
                  alt="remove"
                  style={{ cursor: 'pointer' }}
                  onClick={() => setTemplateFile(null)}
                />
              </div>
            </div>
          )}

          <div className="divider w-100 my-4"></div>
          <div className="d-flex align-items-center gap-24">
            <p className="font-12 mb-0">Your file is securely uploaded to the server.</p>
            <button className="theme-outline-btn" onClick={handleClose}>Cancel</button>
            <button className="theme-sky-btn text-nowrap" onClick={uploadTemplate}>Upload</button>
          </div>
        </Modal.Body>
      </Modal>

      <SuccessModal show={showSuccess} handleClose={handleSuccessClose} />
    </>
  );
};

export default TemplateUploadModal;
